"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _UnauthorizedPage = _interopRequireDefault(require("settings-ui-sdk/Auth/UnauthorizedPage"));

var _ThemesSettingsContainer = _interopRequireDefault(require("./ThemesSettingsContainer"));

var SitemapsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SitemapsContainer, _PureComponent);

  function SitemapsContainer() {
    (0, _classCallCheck2.default)(this, SitemapsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SitemapsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(SitemapsContainer, [{
    key: "render",
    value: function render() {
      if (!this.props.hasThemesAccess) {
        return _react.default.createElement(_UnauthorizedPage.default, {
          moduleName: "website.themes",
          includeNextStep: false
        });
      }

      return _react.default.createElement(_ThemesSettingsContainer.default, null);
    }
  }]);
  return SitemapsContainer;
}(_react.PureComponent);

SitemapsContainer.propTypes = {
  hasThemesAccess: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasThemesAccess: (0, _selectors.getHasThemesAccess)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(SitemapsContainer);

exports.default = _default;
module.exports = exports.default;